var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAddSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 2.75618C5.05416 2.75618 2.66634 5.144 2.66634 8.08952C2.66634 11.035 5.05416 13.4229 7.99967 13.4229C10.9452 13.4229 13.333 11.035 13.333 8.08952C13.333 5.144 10.9452 2.75618 7.99967 2.75618ZM1.33301 8.08952C1.33301 4.40762 4.31778 1.42285 7.99967 1.42285C11.6816 1.42285 14.6663 4.40762 14.6663 8.08952C14.6663 11.7714 11.6816 14.7562 7.99967 14.7562C4.31778 14.7562 1.33301 11.7714 1.33301 8.08952ZM7.99968 4.42285C8.36787 4.42285 8.66634 4.72133 8.66634 5.08952L8.66634 7.42285H10.9997C11.3679 7.42285 11.6663 7.72133 11.6663 8.08952C11.6663 8.45771 11.3679 8.75619 10.9997 8.75619H8.66634V11.0895C8.66634 11.4577 8.36786 11.7562 7.99967 11.7562C7.63148 11.7562 7.33301 11.4577 7.33301 11.0895V8.75619H4.99967C4.63148 8.75619 4.33301 8.45771 4.33301 8.08952C4.33301 7.72133 4.63148 7.42285 4.99967 7.42285H7.33301L7.33301 5.08952C7.33301 4.72133 7.63149 4.42285 7.99968 4.42285Z",
    fill: "#05308D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddSquare);
export default __webpack_public_path__ + "static/media/ic-add-square.3a55c8e9f79b39c3244a0722e189d1e9.svg";
export { ForwardRef as ReactComponent };